import React from 'react';
import { FaShieldAlt, FaUsers, FaStar, FaChartLine } from 'react-icons/fa';
import SEO from '../components/SEO';

const About: React.FC = () => {
  return (
    <>
      <SEO
        title="About Us - SpinHarvester UK Casino Reviews"
        description="Learn about SpinHarvester, your trusted source for comprehensive UK casino reviews, expert analysis, and exclusive bonus offers."
        schema={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          mainEntity: {
            '@type': 'Organization',
            name: 'SpinHarvester',
            description: 'UK casino review and comparison platform'
          }
        }}
      />

      <div className="min-h-screen bg-gray-50">
        <section className="bg-gradient-to-br from-primary-50 to-white py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About SpinHarvester
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Your trusted source for comprehensive UK casino reviews and exclusive offers
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                At SpinHarvester, we're dedicated to helping UK players make informed decisions about online casinos. 
                Our team of experts thoroughly reviews each casino, testing everything from game selection to payout speeds, 
                ensuring you have all the information you need to choose the perfect casino for your needs.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                We understand that choosing an online casino can be overwhelming with so many options available. 
                That's why we've created a comprehensive platform that simplifies the process, providing detailed reviews, 
                side-by-side comparisons, and exclusive bonus offers you won't find anywhere else.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">What We Do</h2>
              <div className="grid md:grid-cols-2 gap-6 mb-12">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <FaShieldAlt className="text-4xl text-primary-600 mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Licensed Casinos Only</h3>
                  <p className="text-gray-700">
                    We only review casinos licensed by the UK Gambling Commission, ensuring your safety and security.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <FaStar className="text-4xl text-primary-600 mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Reviews</h3>
                  <p className="text-gray-700">
                    Our team of experienced reviewers test every aspect of each casino, from bonuses to customer service.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <FaChartLine className="text-4xl text-primary-600 mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Detailed Comparisons</h3>
                  <p className="text-gray-700">
                    Compare casinos side-by-side to find the best match for your gaming preferences and budget.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <FaUsers className="text-4xl text-primary-600 mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Player-Focused</h3>
                  <p className="text-gray-700">
                    Everything we do is focused on helping players make better decisions and have better experiences.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Values</h2>
              <ul className="space-y-4 text-gray-700 mb-12">
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 font-bold text-xl">✓</span>
                  <span><strong>Transparency:</strong> We provide honest, unbiased reviews based on real testing and experience.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 font-bold text-xl">✓</span>
                  <span><strong>Safety First:</strong> Player safety is our top priority. We only recommend licensed, secure casinos.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 font-bold text-xl">✓</span>
                  <span><strong>Responsible Gambling:</strong> We promote responsible gambling and provide resources for those who need help.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 font-bold text-xl">✓</span>
                  <span><strong>Excellence:</strong> We continuously update our reviews and comparisons to ensure accuracy and relevance.</span>
                </li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                Have questions or feedback? We'd love to hear from you. Reach out to us through our contact form 
                or email us directly. Your input helps us improve and serve the UK gambling community better.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;


